module.exports = new __parcel__URL__("help_text.9b73c352.png").toString();